import { render } from "./app-address-field.vue?vue&type=template&id=3a943816&ts=true"
import script from "./app-address-field.vue?vue&type=script&lang=ts"
export * from "./app-address-field.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__